import React from 'react';
import { theme } from '../../theme';

// Swipe-style pastel section wrapper. Grouping form fields inside a softly
// tinted card makes long forms easier to scan than a flat sea of inputs.
//
// Props:
//   variant   'white' | 'blue' | 'mint' | 'cream' | 'pink' | 'lilac'  — default 'white'
//   bordered  boolean — adds a 1px border in the matching pastel hue
//   title     optional section title rendered top-left
//   subtitle  optional one-liner under title
//   right     optional ReactNode rendered top-right (e.g. action button)
//   padding   override default 18px padding
const VARIANT_BG = {
  white: theme.surface,
  blue:  theme.sectionBlue,
  mint:  theme.sectionMint,
  cream: theme.sectionCream,
  pink:  theme.sectionPink,
  lilac: theme.sectionLilac,
};
const VARIANT_BORDER = {
  white: theme.border,
  blue:  theme.sectionBlueBorder,
  mint:  theme.sectionMintBorder,
  cream: theme.sectionCreamBorder,
  pink:  theme.sectionPinkBorder,
  lilac: theme.sectionLilacBorder,
};

export default function SectionCard({
  variant = 'white',
  bordered = false,
  title,
  subtitle,
  right,
  padding = '18px',
  children,
  style,
  className,
}) {
  const bg = VARIANT_BG[variant] || theme.surface;
  const border = bordered ? `1px solid ${VARIANT_BORDER[variant] || theme.border}` : `1px solid ${theme.border}`;
  return (
    <div
      className={className}
      style={{
        backgroundColor: bg,
        border,
        borderRadius: theme.radiusLg,
        padding,
        marginBottom: '14px',
        ...style,
      }}
    >
      {(title || right) && (
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '12px' }}>
          {title && (
            <div>
              <h3 style={{ margin: 0, color: theme.navy, fontSize: '0.95rem', fontWeight: '700' }}>{title}</h3>
              {subtitle && <p style={{ margin: '2px 0 0', color: theme.textMuted, fontSize: '0.8rem' }}>{subtitle}</p>}
            </div>
          )}
          {right && <div>{right}</div>}
        </div>
      )}
      {children}
    </div>
  );
}
